<template>
  <div id="footer">
    <div class="infoot">
      <p class="text">
        公司地址：北京市海淀区莲花苑838室
        平台服务热线：010-88614688<br />
        人才招聘：010-88610601 商务合作：010-88619537
      </p>
      <ul>
        <li>
          <img src="/img/erwm01.jpg" />
          <p>微信公众号</p>
        </li>
       
      </ul>
    </div>
    <div class="bot-fot">
      版权所有：北京四维安信软件有限公司 ICP备案号：<a
        href="http://beian.miit.gov.cn"
        title="京ICP备19009628号-1"
        target="_blank"
        style="color: white"
        >京ICP备19009628号-1</a
      >
    </div>
    <RightBar />
  </div>
</template>
<script setup>
import RightBar from "@/components/RightBar.vue";
</script>
<style lang="scss">
#footer {
  position: relative;
  width: 100%;
  background: #1a1a1a;

  .infoot {
    max-width: 1166px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 18.75rem;

    .text {
      font-size: 0.88rem;
      line-height: 280%;
      padding-top: 7rem;
      color: #fff;
    }

    ul {
      position: absolute;
      right: 0;
      top: 80px;
      display: flex;
      justify-content: space-around;

      li {
        p {
          font-size: 1rem;
          text-align: center;
          padding-top: 0.5rem;
          letter-spacing: 1px;
          color: #fff;
        }

        margin-left: 0.67rem;
      }
    }
  }

  .bot-fot {
    height: 4.375rem;
    background-color: #000;
    font-size: 0.875rem;
    text-align: center;
    line-height: 4.375rem;
    color: #fff;
  }
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 480px) {
  #footer {
    margin-top: -3rem;
    .infoot {
      padding-bottom: 2rem;
      background: #1a1a1a;
      height: 30rem;

      .text {
        padding-top: 3rem;
        padding-bottom: 3rem;
        width: 100%;
        text-align: center;
      }

      ul {
        position: static;
      }
    }
  }
}
</style>
